import { render, staticRenderFns } from "./organizationChart.vue?vue&type=template&id=460bc63f&scoped=true&"
import script from "./organizationChart.vue?vue&type=script&lang=js&"
export * from "./organizationChart.vue?vue&type=script&lang=js&"
import style0 from "./organizationChart.vue?vue&type=style&index=0&id=460bc63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bc63f",
  null
  
)

export default component.exports